import React from 'react';

import type { PayeurFacture } from '@/types/payeur';

export type PayeurContextType = {
  factures: PayeurFacture[];
  getFactures: (silent?: boolean) => void;
};

const FactureContext = React.createContext<PayeurContextType>({
  factures: [],
  getFactures: () => {},
});

export default FactureContext;
